import { useAuth0 } from "@auth0/auth0-react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useOfflineAuthenticatedStatus } from "hooks/useOfflineAuthenticatedStatus";
import _ from "lodash";
import React from "react";
import { useLocation } from "react-router-dom";
import { localizationService } from "services/localization-service";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { urlService } from "../services/url-service";
import { AdminSidebar } from "./admin/AdminSidebar";
import { MainSidebar } from "./dashboards/MainSidebar";
import { WylooPortalNavbar } from "./microsites/wyloo/wyloo-portal-navbar";
import Navbar from "./Navbar";
export default function Layout(props) {
  const location = useLocation();
  const dimensions = useWindowDimensions();
  const [waitingWorker, setWaitingWorker] = React.useState(null);
  const [showReload, setShowReload] = React.useState(false);
  const { isAuthenticated } = useAuth0();

  const isOfflineAuthenticated = useOfflineAuthenticatedStatus();
  const authenticated =
    isAuthenticated || (isOfflineAuthenticated && !navigator.onLine);
  const hasNoOverflow = () => {
    if (_.toLower(location.pathname) == "/events" && dimensions.isMobile) {
      return true;
    }
    return false;
  };

  const isRuby = () => {
    if (_.toLower(location.pathname) == "/ruby-ai") {
      return true;
    }
    return false;
  };

  const isOffline = () => {
    return _.toLower(location.pathname).includes("/offline/");
  };
  const reloadPage = () => {
    waitingWorker?.postMessage({ type: "SKIP_WAITING" });
    setShowReload(false);
    window.location.reload(true);
  };
  const hasNoSidebar = () => {
    if (_.toLower(location.pathname) == "/organizations") {
      return true;
    }
    if (isOffline()) {
      return true;
    }

    return false;
  };

  const isMicrosite = () => {
    if (
      _.toLower(location.pathname) == "/investor" ||
      _.toLower(location.pathname) == "/wyloo" ||
      _.toLower(location.pathname).includes("/wyloo/")
    ) {
      return true;
    }
    return false;
  };

  const isOrganizationPortalPublicPage = () => {
    return _.toLower(location.pathname).startsWith("/p/");
  };

  React.useEffect(() => {
    const handler = () => {
      setShowReload(true);
      setWaitingWorker(window.__waitingWorker);
    };
    window.addEventListener("swUpdated", handler);
    return () => window.removeEventListener("swUpdated", handler);
  }, []);
  return (
    <>
      {!isMicrosite() && !isRuby() && !isOrganizationPortalPublicPage() && (
        <Navbar />
      )}
      {isMicrosite() && <WylooPortalNavbar />}
      {urlService.isPublicScreen(authenticated) ? (
        <> {props.children} </>
      ) : (
        <>
          {authenticated && !isOffline() && (
            <>
              {!urlService.isAdminScreen() ? (
                document.location.pathname.toLowerCase() !=
                  "/organizations" && <MainSidebar className="d-print-none" />
              ) : (
                <AdminSidebar />
              )}
            </>
          )}

          <div
            className={`${
              hasNoOverflow()
                ? "content-wrapper-no-overflow"
                : "content-wrapper"
            } ${!hasNoSidebar() ? "padding-left-sidebar" : ""} d-print-block`}
          >
            {props.children}
          </div>
        </>
      )}

      <Dialog open={showReload}>
        <DialogTitle>
          {localizationService.getLocalizedString(
            "screen.dialogs.newVersionAvailable"
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {localizationService.getLocalizedString(
              "screen.dialogs.newVersionDescription"
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowReload(false)}>
            {localizationService.getLocalizedString("screen.buttons.cancel")}
          </Button>
          <Button onClick={reloadPage}>
            {localizationService.getLocalizedString("screen.buttons.refresh")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
